import { ISelect, Select } from ".";
import { levelExpertise } from "../../../util/GlobalData";
import { textChooser } from "../../../util/textChooser";

interface ExpertiseLevelProps extends ISelect {}

export const ExpertiseLevel = (props: ExpertiseLevelProps) => {

    return(
        <Select
            {...props}
            currentValue={props?.currentValue}
            values={levelExpertise}
            label={props?.label ?? textChooser("txt145")}
            hook={props?.hook}
        />
    )
}